import {Component, input, ChangeDetectionStrategy} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
    selector: 'app-certificate-address',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe
    ],
    templateUrl: './certificate-address.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './certificate-address.component.scss'
})
export class CertificateAddressComponent {
  parentFormGroup = input.required<FormGroup>();
  streetNumber = input.required<string>();
  streetDirection = input.required<string>();
  streetName = input.required<string>();
  streetType = input.required<string>();
  unitNumber = input.required<string>();
  city = input.required<string>();
  zipCode = input.required<string>();
}
